import './ErrorBoundary.scss';
import { Alert } from 'antd';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
const messageText = NOTIFICATIONS_COPY.ERROR_UNHANDLED_CONTACT_WITH_MESSAGE;
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        this.setState({
            error,
            errorInfo: info,
            hasError: true
        });
    }
    render() {
        var _a;
        if (!this.state.hasError) {
            return this.props.children;
        }
        return (React.createElement("div", { className: 'error-boundary' },
            React.createElement(Alert, { description: React.createElement("div", null,
                    React.createElement("b", null, messageText),
                    React.createElement("br", null),
                    React.createElement("p", { className: 'error-info' }, (_a = this.state.error) === null || _a === void 0 ? void 0 :
                        _a.toString(),
                        React.createElement("br", null),
                        JSON.stringify(this.state.errorInfo, null, 2).toString())), message: NOTIFICATIONS_COPY.ERROR_UNHANDLED, type: 'error' })));
    }
}
